import './table.scss';

import React, { PropsWithChildren } from 'react';
import { Table as RsTable, TableProps as RsTableProps } from 'reactstrap';

export const Table = ({ children, ...props }: PropsWithChildren<RsTableProps>) => {
  return <RsTable {...props}>{children}</RsTable>;
};
